import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoRobot24 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M12 2.59619C12.5523 2.59619 13 3.04391 13 3.59619V4.39111H18.9551C20.003 4.39111 20.8525 5.24067 20.8525 6.28857V8.17236C21.3857 8.45207 21.75 9.00995 21.75 9.65381V10.5513C21.75 11.1951 21.3857 11.753 20.8525 12.0327V15.7114C20.8525 17.7507 19.1994 19.4038 17.1602 19.4038H6.83984C4.80065 19.4038 3.14746 17.7507 3.14746 15.7114V12.0327C2.61429 11.753 2.25 11.1951 2.25 10.5513V9.65381L2.25879 9.48291C2.31674 8.91204 2.66207 8.427 3.14746 8.17236V6.28857C3.14746 5.24065 3.997 4.39111 5.04492 4.39111H11V3.59619C11 3.04391 11.4477 2.59619 12 2.59619ZM5.14746 15.7114C5.14746 16.6461 5.9052 17.4038 6.83984 17.4038H17.1602C18.0948 17.4038 18.8525 16.6461 18.8525 15.7114V6.39111H5.14746V15.7114ZM14.0195 13.1411C14.5717 13.1413 15.0195 13.5889 15.0195 14.1411C15.0195 14.6933 14.5717 15.141 14.0195 15.1411H9.98047C9.42834 15.141 8.9805 14.6933 8.98047 14.1411C8.98047 13.5889 9.42832 13.1413 9.98047 13.1411H14.0195ZM9.03027 8.43799C9.87383 8.52377 10.5322 9.23684 10.5322 10.103C10.532 11.0267 9.78307 11.7757 8.85938 11.7759C7.99319 11.7759 7.28013 11.1175 7.19434 10.2739L7.18555 10.103L7.19434 9.93115C7.28018 9.08767 7.99324 8.4292 8.85938 8.4292L9.03027 8.43799ZM15.1406 8.4292C16.0646 8.4292 16.8145 9.17901 16.8145 10.103C16.8142 11.0268 16.0645 11.7759 15.1406 11.7759C14.2746 11.7757 13.5623 11.1173 13.4766 10.2739L13.4678 10.103L13.4766 9.93115C13.5624 9.0878 14.2747 8.4294 15.1406 8.4292Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoRobot24;